const API_BASE_URL = import.meta.env.VITE_API_URL;

export const API_ENDPOINTS = {
  // Auth
  GOOGLE_CALLBACK: `${API_BASE_URL}/auth/google/callback`,

  // Modules
  GET_MODULES: `${API_BASE_URL}/modules/`,
  GET_MODULE: (id: string) => `${API_BASE_URL}/modules/${id}`,
  GET_SUB_MODULES: (moduleId: string) => `${API_BASE_URL}/modules/${moduleId}/sub-modules`,
  GET_MODULE_COURSES: (subModuleId: string) => `${API_BASE_URL}/sub-modules/${subModuleId}/courses`,
  GET_SUB_MODULE_PROGRESS: (subModuleId: string) => `${API_BASE_URL}/sub-modules/${subModuleId}/progress`,
  GET_COURSE_PROGRESS: (courseId: string) => `${API_BASE_URL}/courses/${courseId}/progress`,
  UPDATE_COURSE_PROGRESS: (courseId: string) => `${API_BASE_URL}/courses/${courseId}/progress`,
  GET_MODULE_PROGRESS: (moduleId: string) => `${API_BASE_URL}/modules/${moduleId}/progress`,

  // Courses
  GET_COURSE_CONTENT: (courseId: string) => `${API_BASE_URL}/courses/${courseId}/content`,
  GET_FEATURED_COURSES: `${API_BASE_URL}/courses/featured`,

  // Quiz
  GET_QUIZ_QUESTIONS: `${API_BASE_URL}/quiz/questions`,
  SAVE_QUIZ_RESULT: `${API_BASE_URL}/quiz/results`,
  GET_QUIZ_STATISTICS: `${API_BASE_URL}/quiz/statistics`,

  // User
  GET_USER_PROFILE: `${API_BASE_URL}/user/profile`,
  GET_USER_PROGRESS: `${API_BASE_URL}/user/progress`,
  CHECK_FIRST_CONNECTION: `${API_BASE_URL}/user/first-connection`,
  DELETE_ACCOUNT: `${API_BASE_URL}/user/`,
  CHECK_INVOICE_STATUS: `${API_BASE_URL}/payments/invoice-status`,
  PREVIEW_UPGRADE: `${API_BASE_URL}/payments/preview-upgrade`,
  CANCEL_SUBSCRIPTION: `${API_BASE_URL}/subscriptions/cancel`,
  SET_USER_OBJECTIVE: (objective: string) => `${API_BASE_URL}/user/objective?objective=${encodeURIComponent(objective)}`,

  // Testimonials
  GET_TESTIMONIALS: `${API_BASE_URL}/testimonials`,

  // Subscriptions
  CREATE_SUBSCRIPTION: `${API_BASE_URL}/payments/subscribe`,
};